import { AdvancedHero } from 'app/components/AdvancedHero'
import { AdvancedIntro } from 'app/components/AdvancedIntro'
import { Banner } from 'app/components/Banner'
import { Location } from 'app/components/Location'
import { RoomsCard } from 'app/components/RoomsCard'
import { SEO } from 'app/components/SEO'
import { ServicesPreview } from 'app/components/ServicesPreview'
import { SocialWall } from 'app/components/SocialWall'
import {
  Props as StructuredDataProps,
  StructuredData,
} from 'app/components/StructuredData'
import { VisualGallery } from 'app/components/VisualGallery'
import { Footer, Props as FooterProps } from 'app/containers/Footer'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
}

export interface Context extends PageContext {
  props: Props
}

export const Head = ({ pageContext }: PageProps<void, Context>) => {
  const context = pageContext as any

  return <SEO {...context.seoProps} />
}

export default memo(function HomePageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <>
      {context.headerProps ? (
        <Header
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          pageID={context.id}
          flashNewsProps={
            context.flashNewsProps ? context.flashNewsProps : null
          }
          benefitsSticker={true}
          benefitsProps={context.benefitsProps ? context.benefitsProps : null}
          {...context.headerProps}
        />
      ) : null}
      {context.advancedHeroProps ? (
        <AdvancedHero {...context.advancedHeroProps} />
      ) : null}
      {context.advancedIntroProps ? (
        <AdvancedIntro counter="01" {...context.advancedIntroProps} />
      ) : null}
      {/*  
      
      TO USE FOR HOTEL VIRGILIO

      {context.visualRoomsProps ? (
        <VisualGallery
          variant="light"
          counter="02"
          {...context.visualRoomsProps}
        />
      ) : null} 
       */}
      {context.roomsCardProps ? (
        <RoomsCard counter="02" {...context.roomsCardProps} />
      ) : null}
      {context.bannerProps ? <Banner {...context.bannerProps} /> : null}
      {context.servicesPreviewProps ? (
        <ServicesPreview counter="03" {...context.servicesPreviewProps} />
      ) : null}
      {context.visualGalleryProps ? (
        <VisualGallery counter="04" {...context.visualGalleryProps} />
      ) : null}
      {context.locationProps ? (
        <Location counter="05" {...context.locationProps} />
      ) : null}
      {context.socialWallProps ? (
        <SocialWall counter="06" {...context.socialWallProps} />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}

      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
    </>
  )
})
